import { CardBody, Card, Flex, Text, Stack } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { ClientTeamMembership } from '../../../../../types/clientTeamMembership'
import { AvatarBubblesSmall } from '../AvatarBubblesSmall/AvatarBubblesSmall'
import GlobalHelpers from '../../../../../charts/lib/Helpers'

export const MSG = defineMessages({
  license: {
    id: 'PreferredPartnerCard.license',
    defaultMessage: 'License #{license}'
  },
  nmls: {
    id: 'PreferredPartnerCard.nmls',
    defaultMessage: 'MLS #{nmls}'
  }
})

export const PreferredAgentCard = ({ clientTeamMembership }: { clientTeamMembership: ClientTeamMembership }) => {
  const intl = useIntl()

  const formattedPhone = GlobalHelpers.formatPhone(clientTeamMembership?.customerProfile?.phone, true)
  return (
    <Card 
      my='4' 
      size='sm' 
      bg='neutral.100' 
      borderColor='whiteAlpha.300'
      borderRadius='md'
      boxShadow='lg'
      width='100%'
    >
      <CardBody p='9px'>
        <Flex alignItems='center' justifyContent='flex-start' mb='0' maxHeight='108px'>
          {(clientTeamMembership.customerProfile.photoUri || clientTeamMembership.corporateProfile?.avatarUri) && (
            <AvatarBubblesSmall
              photoUri={clientTeamMembership.customerProfile.photoUri}
              companyLogo={clientTeamMembership.corporateProfile?.avatarUri}
            />
          )}
          <Stack direction='column' spacing='0' px='3' flex='1'>
            <Text size='sm' color='neutral.900' fontWeight='semibold' mb='0'>
              {clientTeamMembership.customerProfile.firstName} {clientTeamMembership.customerProfile.lastName}
            </Text>
            {clientTeamMembership.corporateProfile?.name && (
              <Text size='3xs' color='neutral.700' mb='0' fontWeight='semibold' textTransform='uppercase'>
                {clientTeamMembership.corporateProfile?.name}
              </Text>
            )}
            {clientTeamMembership.customerProfile.stateLicense && (
            <Text size='3xs' color='neutral.700' mb='0'>
              {intl.formatMessage(MSG.license, { license: clientTeamMembership.customerProfile.stateLicense })}
            </Text>
            )}
            {clientTeamMembership.customerProfile.nmlsId && (
            <Text size='3xs' color='neutral.700' mb='0'>
              {intl.formatMessage(MSG.nmls, { nmls: clientTeamMembership.customerProfile.nmlsId })}
            </Text>
            )}
            {formattedPhone && (
            <Text size='3xs' color='neutral.700' mb='0'>
              {formattedPhone}
            </Text>
            )}
            {clientTeamMembership.customerProfile.email && (
              <Text size='3xs' color='neutral.700' mb='0'>
                {clientTeamMembership.customerProfile.email}
              </Text>
            )}
          </Stack>
        </Flex>
      </CardBody>
    </Card>
  )
}
